import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIssueInventory = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#111",
		d: "M15.571 7 12 10.571 8.429 7 7 8.429 10.571 12 7 15.571 8.429 17 12 13.429 15.571 17 17 15.571 13.429 12 17 8.429 15.571 7z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "M2 2h20v20H2V2zm2 2h16v16H4V4z",
		clipRule: "evenodd"
	})]
});
export default SvgIssueInventory;
